export default "__VITE_ASSET__Q1NwXD9s__"